import React, { useState, useEffect } from 'react';
import { Space, Table, Button, Input } from 'antd';
import { useLazyQuery } from '@apollo/client';
import moment from 'moment';

import { FETCH_ADMIN_TRANSACTIONS } from 'graphql/queries/adminQueries';

const limit = 10;

const TransactionDetails = () => {
  const [adminTransactions, setAdminTransactions] = useState([]);
  const [cursorPaging, setCursorPaging] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [queryString, setQueryString] = useState('');

  const transactionColumn = [
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Kind',
      dataIndex: 'kind',
      key: 'kind',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'User Details',
      dataIndex: 'uid',
      key: 'uid',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Txn id',
      dataIndex: 'txnId',
      key: 'txnId',
    },
    {
      dataIndex: 'transData',
      key: 'transData',
    },
  ];

  const updateAdminTransactions = (transactions, shouldConcat = false) => {
    const newTransactions = transactions.map((transaction) => ({
      _id: transaction._id,
      createdAt: moment(transaction.time).format('DD/MM/YYYY hh:mm:ss'),
      type: transaction.trans.txn_type || transaction.type || '?',
      uid: transaction.uid,
      amount: transaction.trans.mc_gross,
      txnId: transaction.trans.txn_id,
      kind: transaction.trans.item_number || transaction.trans.product_name,
      transData: transaction.trans,
    }));

    setAdminTransactions([...(shouldConcat ? adminTransactions : []), ...newTransactions]);
  };

  const processFetchedData = (data, shouldConcat = false) => {
    if (data?.fetchAdminTransactions) {
      const { transactions, pagingMetadata } = data.fetchAdminTransactions;

      updateAdminTransactions(transactions, shouldConcat);
      setCursorPaging(pagingMetadata);
    }
    setIsFetching(false);
  };

  const [fetchAdminTransactions, { refetch, fetchMore }] = useLazyQuery(FETCH_ADMIN_TRANSACTIONS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => processFetchedData(data),
  });

  useEffect(() => {
    setIsFetching(true);
    fetchAdminTransactions({
      variables: { queryString, limit },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryString]);

  const loadMore = async () => {
    setIsFetching(true);
    const { data } = await fetchMore({
      variables: {
        queryString,
        limit,
        cursorPaging: cursorPaging?.cursor,
      },
    });
    processFetchedData(data, true);
  };

  const refetchTransactions = async () => {
    setIsFetching(true);

    const { data } = await refetch({ queryString, limit });
    processFetchedData(data);
  };

  const handleReset = () => {
    setQueryString('');
  };

  return (
    <div>
      {/* <GeneralStats /> */}
      <div className="admin-table-wrapper">
        <div className="table-action">
          <h3>All Transactions</h3>
          <div>
            <div />
            <Space>
              <Input.Search
                width="200"
                placeholder="Email/Uid"
                value={queryString}
                onChange={(e) => setQueryString(e.target.value)}
                onSearch={refetchTransactions}
              />
              <Button type="primary" onClick={handleReset}>
                Reset
              </Button>
            </Space>
          </div>
        </div>
        <Table
          loading={isFetching}
          rowClassName={(record) =>
            record.transData &&
            parseFloat(record.transData.mc_gross) >= 1 &&
            record.transData.type !== 'pdt' &&
            ((record.transData.txn_type === 'web_accept' &&
              record.transData.payment_status === 'Completed') ||
              record.transData.txn_type === 'recurring_payment')
              ? 'table-row-dark'
              : 'table-row-light'
          }
          dataSource={adminTransactions}
          columns={transactionColumn}
          rowKey={'_id'}
          pagination={false}
          footer={() => (
            <div>
              {cursorPaging?.hasNext && (
                <Button
                  loading={isFetching}
                  disabled={isFetching}
                  className="medium-btn white-btn"
                  onClick={loadMore}>
                  Load more
                </Button>
              )}
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default TransactionDetails;
